/*
  This is the list of dial codes for all countries.
  They are arranged in an order that matches the order of the countries
  from the file './countries.constant.ts' 
*/
const COUNTRY_DIAL_CODES = [
  '93',
  '355',
  '213',
  '1',
  '376',
  '244',
  '1',
  '672',
  '1',
  '54',
  '374',
  '297',
  '61',
  '43',
  '994',
  '1',
  '973',
  '880',
  '1',
  '375',
  '32',
  '501',
  '229',
  '1',
  '975',
  '591',
  '387',
  '267',
  '55',
  '246',
  '1',
  '673',
  '359',
  '226',
  '257',
  '855',
  '237',
  '1',
  '238',
  '1',
  '236',
  '235',
  '56',
  '86',
  '61',
  '61',
  '57',
  '269',
  '682',
  '506',
  '385',
  '53',
  '599',
  '357',
  '420',
  '243',
  '45',
  '253',
  '1',
  '1',
  '670',
  '593',
  '20',
  '503',
  '240',
  '291',
  '372',
  '251',
  '500',
  '298',
  '679',
  '358',
  '33',
  '689',
  '241',
  '220',
  '995',
  '49',
  '233',
  '350',
  '30',
  '299',
  '1',
  '1',
  '502',
  '44',
  '224',
  '245',
  '592',
  '509',
  '504',
  '852',
  '36',
  '354',
  '91',
  '62',
  '98',
  '964',
  '353',
  '44',
  '972',
  '39',
  '225',
  '1',
  '81',
  '44',
  '962',
  '7',
  '254',
  '686',
  '383',
  '965',
  '996',
  '856',
  '371',
  '961',
  '266',
  '231',
  '218',
  '423',
  '370',
  '352',
  '853',
  '389',
  '261',
  '265',
  '60',
  '960',
  '223',
  '356',
  '692',
  '222',
  '230',
  '262',
  '52',
  '691',
  '373',
  '377',
  '976',
  '382',
  '1',
  '212',
  '258',
  '95',
  '264',
  '674',
  '977',
  '31',
  '599',
  '687',
  '64',
  '505',
  '227',
  '234',
  '683',
  '850',
  '1',
  '47',
  '968',
  '92',
  '680',
  '970',
  '507',
  '675',
  '595',
  '51',
  '63',
  '64',
  '48',
  '351',
  '1',
  '974',
  '242',
  '262',
  '40',
  '7',
  '250',
  '590',
  '290',
  '1',
  '1',
  '590',
  '508',
  '1',
  '685',
  '378',
  '239',
  '966',
  '221',
  '381',
  '248',
  '232',
  '65',
  '1',
  '421',
  '386',
  '677',
  '252',
  '27',
  '82',
  '211',
  '34',
  '94',
  '249',
  '597',
  '47',
  '268',
  '46',
  '41',
  '963',
  '886',
  '992',
  '255',
  '66',
  '228',
  '690',
  '676',
  '1',
  '216',
  '90',
  '993',
  '1',
  '688',
  '1',
  '256',
  '380',
  '971',
  '44',
  '1',
  '598',
  '998',
  '678',
  '39',
  '58',
  '84',
  '681',
  '212',
  '967',
  '260',
  '263',
  '358',
  '590',
  '596',
];

export { COUNTRY_DIAL_CODES };
